import { useCallback } from "react";
import MailingsService from "../../../services/mailings";
import { useAppDispatch } from "../../../store";
import { setErrorMessage, setSuccessMessage } from "../../../acions/actionsCreators/messageActions";

export const useSendAll = (setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>, reloadData: () => void) => {
  const dispatch = useAppDispatch();

  const sendAll = useCallback(async () => {
    try {
      setIsDisabled(true);

      await MailingsService.sendAll();

      dispatch(setSuccessMessage("Emails were queued for sending", true));

      setIsDisabled(false);

      reloadData();
    } catch (e: any) {
      const { response } = e;

      e.response && dispatch(setErrorMessage(response.data.title, true));

      setIsDisabled(false);
    }
  }, [setIsDisabled, dispatch, reloadData]);

  return { sendAll };
};
